export default function getPageType() {
  var _page$pageInfo;

  const _ref = window.digitalData || {},
        page = _ref.page;

  return page == null ? void 0 : (_page$pageInfo = page.pageInfo) == null ? void 0 : _page$pageInfo.pageType;
}